var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceMeShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 47,
    viewBox: "0 0 45 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 47,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_193",
    transform: "matrix(0.0111111 0 0 0.0106383 0 0.0212766)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_193",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADOUlEQVR4nO2cy27TQBSGT7vgIvEAlBWXrLJrznEbWBDgHbolnaHqAolFC/tuYUUFSAUW8A4sUMvtLWh5ApBKBYKCwi5oYldIIU7t2D4Z2/8nzSaX4/Gn37dJZogAAKC6NBp3TorYB8z2i4j5LGLuu9em3a9K0WwunWA2r0Rsf6htdzrdU9PuX9Ul9yFbT3IfsvUk9yFbT3IfsvUk9yFbTzJkK0qGbEXJkD2Me7pjtq/HCRv3fpLv1v4JspksyYOnv7j309SgOtJImOSjNMZ9ZpJatULEPE4jZpzo5LLNJtWLjVkR8ztN+o4TnUy2OSSiGaoPG7PMtpfmEE8i+jjZbptu21QnmM3LNOfRpKLHyWa2L6huNJu3zzjZYbLNIbN9OO5ilUb0P9lmM6rdc5LdNqnGzCT5UFrRQ/XrdF7ORgbRIA0QrYQg0RBdKQSJjofZXmc2z0Xsnoj9lUVWEd+N+rTHbJ8x37pGZYP55iUR+37cuIP4IXr4gebtwsLKBSoDIstXmO1B0p0Tj0RH4yFfg8BeJp9ZXOyeF7H76XbMeiZ6kOwDd1SSrzCbd2l3SjwUHSX7A/lIq7V8Y7Idsp6Kdsn28AIZ3V2MOgx7zGYtCLpns9TPIjq+z6tzzHY9bshWxDwl32A2n0aLNmt51C9C9BHM5m6M6F3yDTccOaqzWZOsIdr1MSYkP8k3ihRRhfq5UXYRAtEhEF0REYJEh0B0RUQIEh0C0RURIUh0CERXRIQg0SEQXRERgkSHQHRFRAgSHQLReiK+/1/ffMuxPoZJHcz2yQjRjygnIDqi3V467X7DC+e+DNqWe41yAqKV/lgO0UpAtBIQrQREKwHRSkC0EhCtBEQrAdFKQLQSEK0ERCsB0UpAtBIQrQREKwHRSpRGtJtYU+RkoSKZn7fnRvWd2f6g8kx/s+vkOSL2Xmmmv7mlGGJE98JJk6tz5BnhhE43x9D8iRG9RT6uzRF3npOStiCwV8lHRMybacuR/No2VW0ZCfGsheuNmIvkM25REbe4yLRlyeRtv9VaaVMZcMvllPM0YnbcUUllQ8R0or9x7cZNyp+yWLdu6Ud3d+HthQ8AAAAAAAAAqGD+ApUoOUgDoCHZAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMeShare);
export default __webpack_public_path__ + "static/media/price-me-share.d658eb8df4d1fa84639dee0ee27fffef.svg";
export { ForwardRef as ReactComponent };